import type { FC } from 'react';

import { unified } from 'unified';
import remarkParse from 'remark-parse';
import remarkRehype from 'remark-rehype';
import rehypeRaw from 'rehype-raw';
import rehypeStringify from 'rehype-stringify';

interface Props {
  className?: string;
  children: string | null | undefined;
}

export const Markdown: FC<Props> = (props) => {
  return (
    <div
      className={props.className}
      dangerouslySetInnerHTML={{
        __html: String(
          unified()
            .use(remarkParse)
            .use(remarkRehype, { allowDangerousHtml: true })
            .use(rehypeRaw)
            .use(rehypeStringify)
            .processSync(
              typeof props.children === 'string' ? props.children : '',
            ),
        ),
      }}
    />
  );
};

Markdown.displayName = 'Core.Markdown';

export default Markdown;
